'use client';
import styles from './styles.module.css';
import Image from 'next/image';
import { casesData } from '../../../constants/items';
import Link from 'next/link';
import { useState, useEffect } from 'react';

export default function CasesSection() {
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 1299);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const handleShowMore = () => {
    setShowAll(true);
  };

  const displayedCases = isMobile && !showAll ? casesData.slice(0, 4) : casesData;
  const shouldShowButton = isMobile && !showAll && casesData.length > 4;

  return (
    <section id="cases" className={styles.casesSection}>
      <div className={styles.casesGrid}>
        {displayedCases.map((caseItem) => (
          <Link key={caseItem.id} href={caseItem.link} className={styles.caseCard} target='_blank'>
            <div className={styles.cardImage}>
              <Image
                src={caseItem.image}
                alt={caseItem.title}
                width={400}
                height={300}
                className={styles.image}
              />
            </div>
            <div className={styles.cardContent}>
              <h3 className={styles.cardTitle}>{caseItem.title}</h3>
              <p className={styles.cardSubtitle}>{caseItem.subtitle}</p>
            </div>
          </Link>
        ))}
      </div>

      {shouldShowButton && (
        <div className={styles.buttonContainer}>
          <button className={styles.viewMoreButton} onClick={handleShowMore}>
            Смотреть ещё
          </button>
        </div>
      )}
    </section>
  );
} 